import React from 'react';
import { message, Modal } from 'antd';
import { generators, network } from '../../../utils';
import api from '../../../config/api';
import './index.less';

export default ({ signinFlag, onSignInSuccessFul }) => {
  const [visible, setViisible] = React.useState(false);
  const [continueSignDays, setContinueSignDays] = React.useState(0); // 连续签到天数
  const [monthPoints, setMonthPoints] = React.useState(0); // 当月签到积分
  const [yearPoints, setYearPoints] = React.useState(0); // 当年签到积分
  const [signList, setSignList] = React.useState([]);
  const [successVisible, setSuccessVisible] = React.useState(false);
  const [isSignin, setIsSignin] = React.useState(false);
  const [currentPointer, setCurrentPointer] = React.useState(0);

  React.useEffect(() => {
    setViisible(true);
    setIsSignin(signinFlag);
  }, []);

  React.useEffect(() => {
    querySignInfos();
  }, []);

  const querySignInfos = async () => {
    const res = await network({
      url: api.core.queryPointsInfo,
      method: 'get',
    });
    if (res.success) {
      const result = generators.generatorObject(res.data);
      if (!result.success) {
        message.error(result.message);
        return;
      }
      const { data = {} } = generators.generatorObject(result);
      const { continueSignDays = 0, monthPoints = 0, yearPoints = 0, signList = [] } = data;
      setContinueSignDays(continueSignDays);
      setMonthPoints(monthPoints);
      setYearPoints(yearPoints);
      setSignList(signList);
    } else {
      message.error(res.message);
    }
  };

  // 立即签到
  const handleSignin = async () => {
    const filterItem = signList.filter((item) => item.checked);
    // eslint-disable-next-line prefer-destructuring
    const { signDay, signPoints } = filterItem[0];
    const res = await network({
      url: api.core.signInConfirm,
      method: 'post',
      data: {
        signDays: signDay,
        signPoints,
      },
    });
    if (res.success) {
      setSuccessVisible(true);
      setIsSignin(true);
      setCurrentPointer(signPoints);
      setContinueSignDays(continueSignDays + 1);
      setMonthPoints(monthPoints + signPoints);
      setYearPoints(yearPoints + signPoints);
      setSignList((preList) => {
        const _list = preList.map((pre) => {
          if (pre.checked) {
            return { ...pre, signFlag: true };
          }
          return pre;
        });
        return _list;
      });
      setTimeout(() => {
        setSuccessVisible(false);
        setViisible(false);
        onSignInSuccessFul && onSignInSuccessFul(true);
      }, 3000);
    } else {
      message.error(res.message);
    }
  };

  const handleClose = () => {
    setViisible(false);
    onSignInSuccessFul && onSignInSuccessFul(false);
  };

  return (
    <>
      <Modal
        visible={visible}
        width={450}
        footer={null}
        wrapClassName="signin-modal"
        maskClosable={false}
        centered={true}
        onCancel={handleClose}
      >
        <div className="wrapper-content">
          <div
            className="wrapper-img"
            style={{
              background: `url('${process.env.TARGET}static/imgs/signin/bg.jpg') center center no-repeat`,
              backgroundSize: 'cover',
            }}
          >
            <div className="modal-content">
              <div className="sign-title">
                <h2>已连续签到</h2>
                <div className="align-center">
                  <span className="title-num">{continueSignDays}</span>
                  <span className="title-day">天</span>
                </div>
              </div>
              <div className="elephant-wrapper">
                <img
                  alt=""
                  src={`${process.env.TARGET}static/imgs/signin/elephant.png`}
                  style={{ width: 220, height: 240 }}
                />
              </div>
              <div
                className="singin-btn pointer"
                style={{
                  background: `url('${process.env.TARGET}static/imgs/signin/btnBg.png') center center no-repeat`,
                  backgroundSize: 'cover',
                }}
                onClick={!isSignin ? handleSignin : () => {}}
              >
                <span>{isSignin ? '今日已签到' : '立即签到'}</span>
              </div>
              <div className="score-summary">
                <div className="score-left">
                  <span>当月签到积分：{monthPoints}</span>
                </div>
                <div className="score-right">
                  <span>年度签到积分：{yearPoints}</span>
                </div>
              </div>
              <div className="score-grid">
                {signList.map((item, index) => {
                  return (
                    <div
                      className={
                        item.signFlag
                          ? 'score-item pointer signin-score-item'
                          : 'score-item pointer'
                      }
                      key={index}
                    >
                      <span>
                        {item.signDay < 5
                          ? item.checked
                            ? '今天'
                            : `第${item.signDay}天`
                          : `4天+`}
                      </span>
                      <img
                        alt=""
                        src={`${process.env.TARGET}static/imgs/signin/goldCoin.png`}
                        style={{ width: 30, height: 30 }}
                      />
                      <span>{item.signPoints}积分</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {successVisible ? (
        <Modal
          visible={successVisible}
          wrapClassName="signedin-modal"
          footer={null}
          closable={false}
          zIndex={1064}
          centered={true}
        >
          <div className="pointer align-center" style={{ width: 450 }}>
            <h2 style={{ color: '#fff', fontWeight: 'bold' }}>
              签到成功！获得+{currentPointer}积分
            </h2>
            <img
              alt=""
              src={`${process.env.TARGET}static/imgs/signin/elephant1.png`}
              style={{ width: 250, height: 280 }}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};
